import axios from "axios";
import { ref } from "vue";
import { functionsUrl } from "@/plugins/firebase";

export const stats = ref<any[]>([]);

export const getAnswerCount = async (key: string, questionId: string) => {
  const response = await axios.get(`${functionsUrl}getAnswerCount`, {
    params: {
      key: key,
      questionId: questionId,
    },
  });

  return response.data;
};

export const getQuestionStats = async () => {
  const response = await axios.get(`${functionsUrl}getQuestionStats`);

  stats.value = Object.values(response.data).map((question: any) => {
    const q = [];
    for (const [key, value] of Object.entries(question.data)) {
      q.push([key, value]);
    }
    return q;
  });
};
